<template>
  <centered-box :title="$t('login.views.loginView.title')">
    <v-expand-transition>
      <alert-component v-if="alert" :type="alert.type" :margin-bottom="9">
        {{ alert.message }}
      </alert-component>
    </v-expand-transition>
    <login-form v-model="formData" :loading="loading" @submit="onSubmit" />
    <div class="py-6">
      <primary-router-link :to="{ name: 'forgot-password' }">
        {{ $t('login.views.loginView.forgotPassword') }}
      </primary-router-link>
    </div>
  </centered-box>
</template>

<script>
import CenteredBox from '@/modules/Login/components/CenteredBox.vue';
import AlertComponent from '@/modules/Layout/components/AlertComponent.vue';
import LoginForm from '@/modules/Login/components/LoginForm.vue';
import PrimaryRouterLink from '@/modules/Layout/components/PrimaryRouterLink.vue';

export default {
  components: {
    CenteredBox,
    AlertComponent,
    LoginForm,
    PrimaryRouterLink,
  },
  data() {
    return {
      alert: false,
      formData: {
        email: '',
        password: '',
      },
      loading: false,
    };
  },
  mounted() {
    if (this.$route?.query?.fpr) {
      this.alert = {
        type: 'success',
        message: this.$t('login.views.loginView.alert.forgottenPasswordReplaced'),
      };
    }
    if (this.$route?.query?.aa) {
      this.alert = {
        type: 'success',
        message: this.$t('login.views.loginView.alert.accountActivated'),
      };
    }
    if (this.$route?.query?.ev) {
      this.alert = {
        type: 'success',
        message: this.$t('login.views.loginView.alert.emailVerified'),
      };
    }
  },
  methods: {
    onSubmit() {
      this.loading = true;
      this.alert = false;
      this.$auth
        .login({
          data: {
            username: this.formData.email,
            password: this.formData.password,
          },
          redirect: false,
        })
        .then(() => {
          this.loading = false;
          this.alert = false;
          if (false === this.$auth.user().current.roles.includes('ROLE_VIEWER')) {
            this.$auth.logout();
            this.alert = {
              type: 'error',
              message: this.$t('login.views.loginView.alert.noViewerRole'),
            };
            return;
          }
          this.$router.push({ name: 'dashboard' });
        })
        .catch((error) => {
          this.loading = false;
          if (401 === error.response?.status) {
            this.alert = {
              type: 'error',
              message: this.$t('login.views.loginView.alert.invalidCredentials'),
            };
          } else {
            this.alert = {
              type: 'error',
              message: this.$t('login.views.loginView.alert.genericError'),
            };
          }
        });
    },
  },
};
</script>
